var map = {
	"./Appartement.jpg": 924,
	"./Garten-mit-Freizeitbereich.jpg": 5281,
	"./Haus-Giovanni-Seitenansicht.jpg": 3409,
	"./Haus-Giovanni.jpg": 8267,
	"./Haus-Pius-Hinteransicht.jpg": 6772,
	"./Haus-Pius-Vorderansicht.jpg": 3362,
	"./Küche-Haus-Pius.jpg": 3933,
	"./Therapieraum-mit-Baellebad.jpg": 1270,
	"./Zimmer-2.jpg": 4368,
	"./Zimmer-3.jpg": 9107,
	"./Zimmer-4.jpg": 3167
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1773;